/**
 * @Author: Colin Osterhout <ctosterhout>
 * @Date:   2019-03-29T10:32:34-08:00
 * @Email:  ctosterhout@alaska.edu
 * @Last modified by:   ctosterhout
 * @Last modified time: 2020-02-17T21:52:53-09:00
 * @License: Released under MIT License. copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
 */

import _ from 'lodash'
import $ from 'jquery'
const TIMEOUT = 30000

// ----------------------------------------------------------------------------
// loadArticles - bring in Student Articles from the specified URL
//
// Returns Promise which resolves with the data obtained from the URL or rejected
// with an Error object.
//
// Utilizes lodash's memoize function to cache the result so that only one fetch
// is made to the same URL.
// ----------------------------------------------------------------------------
const loadArticles = _.memoize(urlArticles => {
  return new Promise((resolve, reject) => {
    // Set a timeout so that we can provide a graceful way to report network issues
    const hTimeout = setTimeout(() => {
      reject(new Error('Timeout loading article data'))
    }, TIMEOUT)

    const isErrorCritical = jqXHR => !(jqXHR.readyState === 0 && jqXHR.status === 0)
    const processData = (data) => {
      // Ensure that studentStory and its image element is an array
      const articles = data.article

      // Clear the timeout now that we've successfully received data and return the processed article array through the resolve mechanism
      clearTimeout(hTimeout)
      resolve(articles)
    }

    // Use jQuery to get the desired article data and then upon receipt run the processData function to massage into usable data
    $.get({
      url: urlArticles,
      dataType: 'json'
    }).done(processData)
      .fail((jqXHR, textStatus) => {
        if (isErrorCritical(jqXHR)) {
          reject(new Error(`Could not load article data. Status: ${textStatus}`))
        }
      })
  })
})

export default loadArticles
